// extracted by mini-css-extract-plugin
module.exports = {"gallery-tile":"GalleryTile_gallery-tile__bhe9r","back":"GalleryTile_back__HbMAN","top":"GalleryTile_top__vWI4F"};